/**
 * HelpText.jsx - 2026-10-13 (Tab 2 plan: helper text rule)
 * One line under an input or in a card that says what it does and which numbers it moves (locales: tab2.help.<id>). The text must stay true to
 * the code (standing rule, memory feedback-helper-text). Optional status chip: SOURCED / DERIVED / EDUCATED_GUESS / NO_DATA.
 */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';
import StatusChip from './StatusChip';

const HelpText = ({ id, status = null, sx = {} }) => {
  const { t } = useTranslation();
  return (
    <Box sx={{ mt: 0.5, mb: 0.5, display: 'flex', alignItems: 'flex-start', gap: 1, ...sx }}>
      <Typography variant="caption" color="text.secondary" sx={{ flex: 1 }}>{t(`tab2.help.${id}`)}</Typography>
      {status && <StatusChip status={status} />}
    </Box>
  );
};

export default HelpText;
